"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartTooltip = require("./ChartTooltip.styled");
function ChartTooltip(_ref) {
  let {
    tooltipRef,
    title = "",
    value = ""
  } = _ref;
  function handleMouseOver() {
    tooltipRef.current.classList.remove("visible");
  }
  return /*#__PURE__*/_react.default.createElement(_ChartTooltip.ChartTooltipWrapper, {
    ref: tooltipRef,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/_react.default.createElement(_ChartTooltip.ChartTooltipTitle, null, title), /*#__PURE__*/_react.default.createElement(_ChartTooltip.ChartTooltipBody, null, /*#__PURE__*/_react.default.createElement("em", null), /*#__PURE__*/_react.default.createElement("span", null, value)));
}
var _default = ChartTooltip;
exports.default = _default;